import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Relatório Analítico',
    path: 'relatorio-analitico',
    name: 'recebimentoitemanaliticobloco',
    component: () => import('@/views/dashboard/recebimento-item/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Relatorio],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Recebimento Consolidado',
    path: 'recebimento-consolidado',
    name: 'recebimentoconsolidadobloco',
    component: () => import('@/views/dashboard/recebimento/Index.vue'),
    meta: { utlTipoFornecimentoId: 301, permissions: [EPermissoes.Relatorio], escopoObra: 'obra' },
    goesToMenu: true
  },

  {
    description: 'Ensaio Consolidado',
    path: 'ensaio-consolidado',
    name: 'ensaioconsolidadoanaliticobloco',
    component: () => import('@/views/dashboard/ensaio-consolidado/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Relatorio],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
];



